import { PartnerDetails } from '../components/Providers/UserSession'
import { SiteMetadata } from '../hooks/useSiteMetadata'

export const mixpanelCookie = 'mpUserId'

export const mixpanelCookieOptions = {
  expires: 365,
  secure: true,
}

export const enum MixpanelDeviceTypes {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

export enum MixpanelCTALinkActions {
  ResumeUploadAction = 'Resume Upload Action',
  EmailSubmitAction = 'Email Submit Action',
}

export enum MixpanelEvents {
  GetMyFreeReviewClickToSubmitResume = 'get_my_free_review_click_to_submit_resume',
  MobileGetMyReviewButton = 'mobile_get_my_review_button',
  ResumeAdded = 'resume_added',
  EmailAddressAddedToResumeUpload = 'email_address_added_to_resume_upload',
  GetMyReviewClickToResumeUpload = 'get_my_review_button_click_to_resume_upload',
  PageView = 'page_view',
  ViewPackagesClick = 'view_packages_click',
  BrowseOurPackagesClicks = 'browse_our_packages_clicks',
  LearnMoreStarterClick = 'learn_more_starter_click',
  LearnMorePremiumClick = 'learn_more_premium_click',
  LearnMoreUltimateClick = 'learn_more_ultimate_click',
  GetExpertHelpClick = 'get_expert_help_click',
  CritiqueScroll25 = 'critique_scroll_25%',
  CritiqueScroll50 = 'critique_scroll_50%',
  CritiqueScroll75 = 'critique_scroll_75%',
  CritiqueScroll100 = 'critique_scroll_100%',
  EnhanceMyResumeClickModal = 'enhance_my_resume_click_modal',
  GetExpertHelpClickModal = 'get_expert_help_modal_click',
  ResumeWritingToggleClick = 'resume_writing_toggle_click',
  JobSearchToggleClick = 'job_search_toggle_click',
  EnhanceMyResumeClickModalLow = 'enhance_my_resume_click_modal_low',
  GetExpertHelpClickModalLow = 'get_expert_help_modal_click_low',
  ResumeWritingToggleClickLow = 'resume_writing_toggle_click_low',
  JobSearchToggleClickLow = 'job_search_toggle_click_low',
}

export type MixpanelPayload = Partial<{
  website_host: string
  user_id: string
  device: MixpanelDeviceTypes
  partner_id: PartnerDetails['partnerId']
  partner_key: SiteMetadata['partnerKey']
  session_id: string
}>

export enum MixpanelEventTypes {
  View = 'view',
  Click = 'click',
  HomePageEvent = 'home_page_event',
  CritiqueEvent = 'critique_event',
  FreeReviewPageEvent = 'free_review_page_event',
  LandingPageEvent = 'landing_page_event',
  JobSearchEvent = 'job_search_event',
  JobSearchEventLow = 'job_search_event_low',
}

export type MixpanelTrackingObject = {
  eventName: string
  trackingData?: null | ContentfulJSON | Record<string, unknown>
  trackOn?: string[] | null
}

export type MixpanelTracking = MixpanelTrackingObject | null

export type ContentfulJSON = {
  internal: {
    content: `"{${string}}"`
  }
}

export const isContentfulJSONType = (
  trackingData?: null | ContentfulJSON | Record<string, unknown>
): trackingData is ContentfulJSON =>
  !!(trackingData as ContentfulJSON)?.internal?.content
